import { BookOpen, ExternalLink, Mic, Youtube } from "lucide-react";
import type { Resource } from "../types";

export const getResourceIcon = (type: Resource["type"]) => {
	switch (type) {
		case "blog":
			return <BookOpen size={24} />;
		case "video":
			return <Youtube size={24} />;
		case "talk":
			return <Mic size={24} />;
		default:
			return <ExternalLink size={24} color="var(--color-text-muted)" />;
	}
};

export const getResourceLabel = (type: Resource["type"]) => {
	switch (type) {
		case "blog":
			return "Article";
		case "video":
			return "Video";
		case "talk":
			return "Conference talk";
		default:
			return "Link";
	}
};
